import classNames from 'classnames';
import React from 'react';
import * as styles from './NestableLink.module.scss';
import Link from './router/Link';

type NestableLinkProps = {
  children?: React.ReactNode;
  className?: string;
  ignoreInsideLinks?: boolean;
  to: string;
} & React.HTMLAttributes<HTMLDivElement> &
  Pick<React.ComponentProps<typeof Link>, 'newTab' | 'onClick'>;

const NestableLink = ({
  children = null,
  to,
  ignoreInsideLinks = false,
  className = undefined,
  'aria-label': ariaLabel,
  newTab,
  ...props
}: NestableLinkProps) => {
  const underlayProps = {
    newTab,
    className: styles.underlay,
    'aria-label': ariaLabel,
  };

  return (
    <div
      className={classNames(styles.nestableLink, className, {
        [styles.allowInsideLinks]: !ignoreInsideLinks,
      })}
      aria-label={ariaLabel}
      {...props}
    >
      {children}
      {/* eslint-disable-next-line jsx-a11y/anchor-has-content */}
      <Link to={to} onClick={props.onClick} {...underlayProps} />
    </div>
  );
};

export default NestableLink;
